<template>
  <div class="w-full max-w-4-xl p-4 bg-gray-200 animate-pulse rounded-lg">
    <div class="w-full h-56 bg-gray-300 rounded-md"></div>
    <div class="p-4">
      <div class="h-6 w-3/4 bg-gray-400 rounded my-2"></div>
      <div class="h-4 w-5/6 bg-gray-300 rounded"></div>
      <div class="h-4 w-2/3 bg-gray-300 rounded mt-2"></div>
    </div>
  </div>
</template>